import PropTypes from 'prop-types';

// material-ui
import { Box, Stack, Typography } from '@mui/material';

// ==============================|| LOGO (full / expanded sidebar) ||============================== //
//
// Icon mark + wordmark, shown when the sidebar is expanded and across the app
// (auth pages, footer, etc.). Uses the Ops Deck teal brand (#0E9498).

const LogoMain = () => {
  // Ops Deck teal stops — a brighter teal into the brand teal — so the mark stays
  // distinct on the dark teal sidebar and reads well on white auth/footer surfaces.
  const primary = '#16B4B8';
  const primaryDark = '#0E9498';

  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <svg
        width="32"
        height="32"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="hexaLogoGradientMain" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop stopColor={primary} />
            <stop offset="1" stopColor={primaryDark} />
          </linearGradient>
        </defs>
        <rect width="36" height="36" rx="9" fill="url(#hexaLogoGradientMain)" />
        <path
          d="M10.5 18.75L15.25 23.5L25.5 12.5"
          stroke="#fff"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, letterSpacing: '-0.02em', color: 'text.primary' }}
      >
        Hexa
        <Box component="span" sx={{ color: '#0E9498' }}>
          {' '}
          Store
        </Box>
      </Typography>
    </Stack>
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool,
};

export default LogoMain;
